import {
  APP_ROUTES_ANC,
  APP_ROUTES_APPOINTMENT,
  APP_ROUTES_APP_ADMISSION,
  APP_ROUTES_APP_ASSIGNED,
  APP_ROUTES_APP_BED_REQUEST,
  APP_ROUTES_APP_DOCUMENT_TEMPLATE,
  APP_ROUTES_APP_DRUG_INVENTORY,
  APP_ROUTES_APP_ENCOUNTERS,
  APP_ROUTES_APP_IMAGING,
  APP_ROUTES_APP_INTAKE,
  APP_ROUTES_APP_LABORATORY,
  APP_ROUTES_APP_MED_ORDER,
  APP_ROUTES_APP_PATIENTS,
  APP_ROUTES_APP_SCHEDULE,
  APP_ROUTES_APP_WAITLIST_DOCTORS,
  APP_ROUTES_APP_WAITLIST_NURSES,
  APP_ROUTES_APP_WAITLIST_RECEPTIONISTS,
  APP_ROUTES_BILLING,
  APP_ROUTES_CHARGE_ITEMS,
  APP_ROUTES_DASHOARD,
  APP_ROUTES_DEPARTMENT,
  APP_ROUTES_HMO,
  APP_ROUTES_INDEX,
  APP_ROUTES_INVENTORY_EQUIPMENT,
  APP_ROUTES_LOCATION,
  APP_ROUTES_PATIENT_DIRECTORY,
  APP_ROUTES_PERMISSION,
  APP_ROUTES_PROCEDURE,
  APP_ROUTES_SHIFT,
  APP_ROUTES_SUPPLIER,
  APP_ROUTES_UNITS
} from '../constants'
import { PermissionLevel, Permissions } from '../types/role.type'

const READ_OR_MANAGE = ['read', 'manage'] as const
const CREATE_OR_MANAGE = ['create', 'manage'] as const
const UPDATE_OR_MANAGE = ['edit', 'manage'] as const
const DELETE_OR_MANAGE = ['manage'] as const

export const hasAccessToReadManage = (
  permissions: Permissions | undefined,
  key: string,
  _requiredPermissions?: string[],
  superAdmin?: boolean
) => {
  if (!permissions) return false
  if (superAdmin) return true
  const permissionLevels = permissions[key] || []

  if (_requiredPermissions && _requiredPermissions.length > 0) {
    return _requiredPermissions.some(permission => permissionLevels.includes(permission as PermissionLevel))
  }

  return permissionLevels.some(permission => READ_OR_MANAGE.includes(permission as (typeof READ_OR_MANAGE)[number]))
}

export const hasAccessToCreateManage = (permissions: Permissions | undefined, key: string, superAdmin?: boolean) => {
  if (!permissions) return false
  if (superAdmin) return true
  const permissionLevels = permissions[key] || []

  return permissionLevels.some(permission => CREATE_OR_MANAGE.includes(permission as (typeof CREATE_OR_MANAGE)[number]))
}

export const hasAccessToUpdateManage = (permissions: Permissions | undefined, key: string, superAdmin?: boolean) => {
  if (!permissions) return false
  if (superAdmin) return true
  const permissionLevels = permissions[key] || []

  return permissionLevels.some(permission => UPDATE_OR_MANAGE.includes(permission as (typeof UPDATE_OR_MANAGE)[number]))
}

export const hasAccessToDeleteManage = (permissions: Permissions | undefined, key: string, superAdmin?: boolean) => {
  if (!permissions) return false
  if (superAdmin) return true
  const permissionLevels = permissions[key] || []

  return permissionLevels.some(permission => DELETE_OR_MANAGE.includes(permission as (typeof DELETE_OR_MANAGE)[number]))
}
export const hasAccessToSidebar = (sidebar_items: string[], permission: string | string[]) => {
  const keys = Array.isArray(permission) ? permission : [permission]
  return keys.some(p => sidebar_items.some(item => item.toLowerCase() === p.toLowerCase()))
}

/** Maps permission keys to routes for redirect when user lacks access to current route. */
export const permissionDic: Record<string, string> = {
  // Admin routes
  appointment: APP_ROUTES_APPOINTMENT,
  department: APP_ROUTES_DEPARTMENT,
  drug: APP_ROUTES_APP_DRUG_INVENTORY,
  equipment: APP_ROUTES_INVENTORY_EQUIPMENT,
  hmo: APP_ROUTES_HMO,
  lab_test: APP_ROUTES_APP_LABORATORY,
  location: APP_ROUTES_LOCATION,
  patient: APP_ROUTES_APP_PATIENTS,
  antenatal: APP_ROUTES_ANC,
  procedure: APP_ROUTES_PROCEDURE,
  role: APP_ROUTES_PERMISSION,
  schedule: APP_ROUTES_APP_SCHEDULE,
  staff: APP_ROUTES_DASHOARD,
  supplier: APP_ROUTES_SUPPLIER,
  shift: APP_ROUTES_SHIFT,
  // User / unified app routes
  intake: APP_ROUTES_APP_INTAKE,
  bed_request: APP_ROUTES_APP_BED_REQUEST,
  medication: APP_ROUTES_APP_MED_ORDER,
  medication_administration: '/mar',
  mar: '/mar',
  document_template: APP_ROUTES_APP_DOCUMENT_TEMPLATE,
  unit: APP_ROUTES_UNITS,
  invoice: APP_ROUTES_BILLING,
  billing: APP_ROUTES_BILLING,
  charge_item: APP_ROUTES_CHARGE_ITEMS,
  encounter: APP_ROUTES_APP_ENCOUNTERS,
  imaging: APP_ROUTES_APP_IMAGING,
  allergy: APP_ROUTES_PATIENT_DIRECTORY,
  admission: APP_ROUTES_APP_ADMISSION,
  assigned_patient: APP_ROUTES_APP_ASSIGNED,
  product: APP_ROUTES_APP_DRUG_INVENTORY,
  pharmaceutical: APP_ROUTES_INDEX,
  doctorswaitinglist: APP_ROUTES_APP_WAITLIST_DOCTORS,
  nurseswaitinglist: APP_ROUTES_APP_WAITLIST_NURSES,
  receptionistswaitinglist: APP_ROUTES_APP_WAITLIST_RECEPTIONISTS,
  receptionistsintake: APP_ROUTES_APP_INTAKE,
  nursesintake: APP_ROUTES_APP_INTAKE
}
